import React from "react";
import './inner-page-content-details.styles.css'

export default function InnerPageContentDetails() {
    return (
        <div className="shbg-pallet white ui segment stackable grid no-border no-padding no-margin no-radius no-shadow">
            <div className="row no-margin no-padding">
                <div className="sixteen wide mobile sixteen wide tablet sixteen wide computer column no-margin no-padding">
                    <div className="container-fluid responsive-padding padding-large">
                        <div className="content-block vertical-align-top">
                            <div id="innerContentDetails" className="inner-content">
                                <div className="ui large header innerContentCentered">
                                    Details
                                </div>
                                <div className="ui small header">
                                    When a building gets constructed, people are not generally counting the effects of greenhouse emissions. It plays a big role in minimizing the carbon footprints that are being left in the environment. In this game, the player will come to know how small contributions will help in minimizing the effect. The game starts with the player selecting a location from the given map. A building will pop up there, and that's the building whose carbon emissions have to be minimized. The following parameters are available to the player for minimizing the emissions: Building Orientation (Affects ventilation, sun & wind exposure), Construction Material (Affects thermal attributes of the building), Construction Wall Thickness (Heat transferred through a slab is inversely proportional to its thickness) & Window Tint (Affects energy consumption). The lesser the carbon emissions generated from the given building, the better a job the player has done.
                                    <br></br>
                                    <br></br>
                                    <div className="innerContentCentered">
                                        Contributors: Ketan Shinde, Rahul Baidya, Suraj Jha, Vidit Vaghela, Ravi Kumar
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}